import { useEffect, useState } from "react";
import Category from "../components/Promo/Category/Category";
import TopSection from "../components/Promo/TopSection/TopSection";

export default function Promo({ cart, setCart }) {
  const [active, setActive] = useState(9);
  const [showAllId, setShowAllId] = useState();
  const [showMessage, setShowMessage] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
  }, [active]);

  useEffect(() => {
    if (!showMessage) return;

    const timeout = setTimeout(() => {
      setShowMessage(false);
    }, 4000);

    return () => clearTimeout(timeout);
  }, [showMessage]);

  return (
    <>
      <TopSection
        active={active}
        setActive={setActive}
        showAllId={showAllId}
        setShowAllId={setShowAllId}
        loading={loading}
        setLoading={setLoading}
      ></TopSection>
      <Category
        active={active}
        cart={cart}
        setCart={setCart}
        showAllId={showAllId}
        setShowAllId={setShowAllId}
        showMessage={showMessage}
        setShowMessage={setShowMessage}
        loading={loading}
        setLoading={setLoading}
      ></Category>
    </>
  );
}
